import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';
import Contact from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen bg-white" data-id="element-1">
        <Navbar data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<AboutUs data-id="element-8" />} data-id="element-7" />
            <Route path="/services" element={<Services data-id="element-10" />} data-id="element-9" />
            <Route path="/contact" element={<Contact data-id="element-12" />} data-id="element-11" />
          </Routes>
        </main>
        <Footer data-id="element-13" />
      </div>
    </BrowserRouter>;
}